		/**
		 * @ngdoc service
		 * @name WebCoreModule.service:WcImageFileService
		 * @requires $q
		 * @requires $window
		 * @description
		 * The WcImageFileService manages the image file related operations.This service is mainly for generating the image related properties.
		 */


angular.module('WebCoreModule')
	.service('WcImageFileService', ['$q', '$window', function($q) { // jshint ignore:line

		// I don't want to make this a public method, but we run into problems testing image.onload.
		// If someone finds a way to mock the Image.onload event, do that and make this method private.
		this.loadImage = angular.bind(this, function(imageSrc, width, height) {
			var deferred = $q.defer();

			var canvas = this.generateCanvas();
			canvas.width = width;
			canvas.height = height;

			var context = canvas.getContext('2d');

			var image = new Image();
			image.onload = function() {
				context.drawImage(image, 0, 0, canvas.width, canvas.height);

				deferred.resolve(canvas);
			};

			image.src = imageSrc;

			return deferred.promise;
		});

		/**
		 * @ngdoc method
		 * @name WcImageFileService.createImageURI
		 * @methodOf WebCoreModule.service:WcImageFileService
		 * @param {String} imageURI This string value holds the image name
		 * @param {Integer} width(optional) This Integer value holds the width of the image. The default value of this field is 200px
		 * @param {Integer} height(optional) This Integer value holds the height of the image. The default value of this field is 200px
		 * @returns {String} The string value is the image uri
		 * @description
		 * The WcImageFileService provides a createImageURI function to create the image uri based on image name, width and height.
		 */

		this.createImageURI = function(imageURI, width, height) {
			width = width || 200;
			height = height || 200;

			return this.loadImage(imageURI, width, height).then(function(canvas) {
				return $q.when(canvas.toDataURL('image/jpeg', 1));
			});
		};

		// Only for testing. We have yet to find out how to mock document.createElement without
		// blowing up angular-mock. We have a Stack Overflow question out there to hopefully
		// find an answer.
		// http://stackoverflow.com/questions/35369629/using-jasmine-to-spy-on-document-createelement-throws-error-from-angular-mock
		this.generateCanvas = function() {
			return document.createElement('canvas');
		};
	}]
);